import { ChargeSessionCodeType } from '../../enums';

const summarize = (chargeSessions: CMxCommonApp.ChargeSession[]) => {
  // filter only for TECH provenances procedures
  let allCodes = chargeSessions
    .map(session => session.codes)
    .flat()
    .filter(
      code => !(code.provenance === 'TECH' && code.codeType === 'procedure')
    );

  // create auxilary unique diagnosis array
  let uniqueDiagnosis = [];
  allCodes = allCodes.filter(code => {
    // just check for diagnosis
    if (code.codeType === 'diagnosis') {
      // if the diagnosis wasn't added, push to the array.
      if (!uniqueDiagnosis.includes(code.code)) {
        uniqueDiagnosis.push(code.code);
        return true;
      } else {
        return false;
      }
    } else {
      // push for other cases
      uniqueDiagnosis.push(code.code);
      return true;
    }
  });

  // sum all codes by code type
  const counts = allCodes.reduce(
    (last, code) => {
      const current = { ...last };
      if (code.codeType === ChargeSessionCodeType.DIAGNOSIS) {
        current.diagnosis++;
      } else if (code.codeType === ChargeSessionCodeType.MODIFIER) {
        current.modifiers++;
      } else if (code.codeType === ChargeSessionCodeType.PROCEDURE) {
        if (code.units !== 0) {
          current.procedures += code.units;
        }
      }
      return current;
    },
    {
      diagnosis: 0,
      procedures: 0,
      modifiers: 0
    }
  );

  return counts;
};

export { summarize };
